import apiClient from 'ps-components/lib/apiClient';
import addAlert from 'ps-components/AlertToast/addAlert';

export const GET_INTERNAL_JOB_LIST = 'GET_INTERNAL_JOB_LIST',
  GET_INTERNAL_JOB_LIST_SUCCESS = 'GET_INTERNAL_JOB_LIST_SUCCESS',
  GET_INTERNAL_JOB_LIST_ERROR = 'GET_INTERNAL_JOB_LIST_ERROR',
  GET_INTERNAL_JOB_LIST_SEARCH_UPDATE = 'GET_INTERNAL_JOB_LIST_SEARCH_UPDATE',
  GET_INTERNAL_JOB_LIST_SELECT_JOB_UPDATE = 'GET_INTERNAL_JOB_LIST_SELECT_JOB_UPDATE',
  GET_INTERNAL_SURVEY_LIST = 'GET_INTERNAL_SURVEY_LIST',
  GET_INTERNAL_SURVEY_LIST_SUCCESS = 'GET_INTERNAL_SURVEY_LIST_SUCCESS',
  GET_INTERNAL_SURVEY_LIST_ERROR = 'GET_INTERNAL_SURVEY_LIST_ERROR',
  RESET_INTERNAL_JOBS_REDUCER = 'RESET_INTERNAL_JOBS_REDUCER',
  INTERNAL_JOBS_GG_RESET = 'INTERNAL_JOBS_GG_RESET';

export function getInternalJobs(searchQuery, currency, limit, offset) {
  return async dispatch => {
    const errorMessage = 'Error retrieving internal company jobs';

    try {
      dispatch({ type: GET_INTERNAL_JOB_LIST });
      const searchFilters = {
        job_price_status: ['priced'],
        currency
      };
      const result = await apiClient.apiPost('/api/jobRanges/search/search', {
        include: searchFilters,
        ...searchFilters,
        exclude: {},
        offset,
        limit,
        es_query: searchQuery,
        facetsLoaded: true,
        elasticSearchFields: [
          'org_job_code_standard^2',
          'work_location_job_code_key_standard^2',
          'org_job_title_standard^5'
        ]
      });

      if (result.status === 200) {
        //WIP: Can refactor/rework after the endpoint returns camelCase
        const payload = {
          searchResultsCount: result.data.searchResultsCount,
          data: result.data.data.map(el => {
            return {
              orgJobId: el.orgJobId,
              orgJobCode: el.org_job_code,
              orgJobCodeKey: el.org_job_code_key,
              orgJobTitle: el.org_job_title,
              currency: el._source?.currency_none,
              description: el._source?.org_job_description_standard
            };
          }),
          offset,
          limit,
          searchQuery
        };
        if (payload.data.length === 0) {
          dispatch({ type: INTERNAL_JOBS_GG_RESET });
        }
        dispatch({ type: GET_INTERNAL_JOB_LIST_SUCCESS, payload });
        return payload.data;
      }
    } catch (error) {
      addAlert(errorMessage, 'danger');
      dispatch({ type: GET_INTERNAL_JOB_LIST_ERROR });
      console.log(error);

      throw error;
    }
  };
}

export function getJobSurveys(job, benchmarkYear, displayIn, search, masterAccountId) {
  return async dispatch => {
    const messageJob = `${job.orgJobTitle}: ${job.orgJobCode}${job.orgJobCodeKey ? ` - ${job.orgJobCodeKey}` : ''}`;
    const errorMessage = `Error retrieving survey jobs for ${messageJob}`;

    try {
      dispatch({ type: GET_INTERNAL_SURVEY_LIST });
      const surveyMatches = await apiClient.apiGet('/api/market-pricing/jobs/jobMatches', {
        params: {
          orgJobCode: job.orgJobCode,
          orgJobCodeKey: job.orgJobCodeKey,
          benchmarkYear: benchmarkYear
        }
      });
      const options = {
        benchmarkYears: [benchmarkYear],
        displayIn: displayIn.toLowerCase(),
        currency: job.currency,
        data: surveyMatches.data.jobMatches.map(match => {
          return { cutId: match.cutId };
        })
      };

      const result = await dispatch(search(`/cms/api/accounts/${masterAccountId}/survey-jobs`, options, 'post'));

      if (result?.result?.status < 300) {
        dispatch({ type: GET_INTERNAL_SURVEY_LIST_SUCCESS, data: surveyMatches.data, selectedJob: job, displayIn });
      } else {
        dispatch({ type: GET_INTERNAL_SURVEY_LIST_ERROR, selectedJob: job });

        // don't show error alert if input data was empty
        if (options.data.length > 0) throw Error(errorMessage);
      }
    } catch (error) {
      addAlert(errorMessage, 'danger');
      dispatch({ type: GET_INTERNAL_SURVEY_LIST_ERROR });
      console.log(error);

      throw error;
    }
  };
}

export function updateSearch(string) {
  return async dispatch => {
    dispatch({ type: GET_INTERNAL_JOB_LIST_SEARCH_UPDATE, data: string });
  };
}

export function updateSelectJob(job) {
  return async dispatch => {
    dispatch({ type: GET_INTERNAL_JOB_LIST_SELECT_JOB_UPDATE, job });
  };
}

export function resetInternalJobsReducer() {
  return { type: RESET_INTERNAL_JOBS_REDUCER };
}
